import * as z from "zod";

export const getShipbobIntegrations = {
  name: "getShipbobIntegrations" as const,
  input: z.object({}),
  output: z.object({
    integrations: z.array(z.object({ _id: z.string(), label: z.string() })),
  }),
};
